module.exports = __webpack_public_path__ + "static/media/chat.25f84375.svg";